<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/B3m8X3/tc-custom/9781615951420.jpg?1731795016758" alt="This image is the cover for the book Commission, Sam Kincaid Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Commission, Sam Kincaid Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Norman is off to a fine start with this alternately gripping and repellent crime novel."—<i>Publishers Weekly</i> STARRED review</b></p><p>Levi Vogue, Chairman of the powerful Utah Board of Pardons and Parole, is gunned down in the driveway of his home as he returns from a late evening tryst with an exotic dancer. Sam Kincaid, Chief of the Special Investigations Branch (SIB) of the Utah Department of Corrections, is assigned to help Salt Lake City Police Department homicide detective Lt. Kate McConnell solve Vogue's murder.</p><p>The investigation draws Kincaid and McConnell into the city's seedy underbelly, where the investigation focuses on Charles (Slick) Watts, a violent ex-convict with a long criminal history and a score to settle with Levi Vogue. But before Watts can be apprehended, his body is discovered at an abandoned military base in Wendover, Nevada.</p><p>Kincaid and McConnell soon expand their theory of the case and are led inside the Utah state prison...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Norman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bc084948